import userStore from 'entities/user/module/user-store'

import { requestAuthRequired } from 'shared/lib/auth-required'
import { getLocalStore } from 'shared/lib/local-store'

export interface Props {
  redirectUrl?: string
  onError?: () => void
  onSuccess?: () => void
}

export const checkUserAuth = ({
  redirectUrl,
  onError,
  onSuccess,
}: Props = {}) => {
  return new Promise(async (resolve, reject) => {
    const isAuthorized = Boolean(
      userStore.account || getLocalStore('mTravelToken'),
    )

    if (isAuthorized) {
      onSuccess?.()
      resolve(true)

      return
    }

    onError?.()

    await requestAuthRequired(redirectUrl || window.location.href)

    reject(false)
  })
}
